import { Component, Input } from '@angular/core';

import { RestaurantService } from '../../../services/restaurant.service';
import { Utils } from '../../util';

/**
 * Generated class for the CardProdutoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'card-produto',
  templateUrl: './card-produto.html',
  styleUrls: ['./card-produto.scss']
})
export class CardProdutoComponent {

  /**
   * Item para ser renderizado no card
   */
  @Input('item') item: any
  /**
   * Estilo de card
   */
  @Input('layout') layout: number = 4

  constructor(
    private restauranteService: RestaurantService,
    public utils: Utils,
  ) { }

  /**
   * Retorna a logo do restaurante
   */
  getImageFromRestaurant() {
    return this.restauranteService.getRestaurant()?.imagem
  }
}
